<template>
  <v-card flat style="background-color: rgba(0,0,0,0);">
    <v-footer height="auto"
              color="purple darken-3"
              class="white--text"
              style="overflow-x: hidden; /*z-index: 1040;*/">
      <v-layout :style="{maxWidth: footerWidth+'px'}" row wrap align-content-space-between>
        <v-flex xs12 style="background-color: #fff; text-align: center" class="custom-show no-print">
          <v-btn small href="http://www.floridaearlylearning.com/" flat color="blue darken-2" class="mx-0" target="_blank">
            <nt-icon>launch</nt-icon><span style="text-transform:none; padding-left: 10px">Division of Early Learning Website</span>
          </v-btn>
        </v-flex>
        <v-flex sm1 hidden-xs-only />
        <v-flex v-nt sm5 xs12>
          <div class="pl-4" v-html="contactInfo" />
          <div id="google_translate_element" class="pl-4 pb-4 hidden-xs-only" />
        </v-flex>
        <v-flex sm5 hidden-xs-only style="text-align: right;" class="no-print">
          <v-flex class="pr-4" v-html="copyrightText" />
        </v-flex>
        <v-flex hidden-sm-and-up xs12>
          <div class="px-4" v-html="copyrightText" />
        </v-flex>
        <v-flex xs12 />
      </v-layout>
    </v-footer>
  </v-card>
</template>

<script>
  export default {
    computed: {
      footerWidth() {
        return (this.$route.path === '/search' && window.innerWidth >= this.$configs.drawerBreakpoint) ? window.innerWidth - 300 : window.innerWidth;
      },
      copyrightText() {
        return this.$store.state.configs.copyrightText;
      },
      contactInfo() {
        return this.$store.state.configs.contactInfo;
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.googleTranslateInit();
      });
    },
    methods: {
      googleTranslateInit() {
        const checkIfGoogleLoaded = setInterval(() => {
          if (window.google && window.google.translate && window.google.translate.TranslateElement) {
            clearInterval(checkIfGoogleLoaded);
            new window.google.translate.TranslateElement(this.$store.state.configs.googleTranslateConfig, 'google_translate_element');
          }
        }, 100);
      }
    }
  }
</script>
